export const LOGIN = '/login';
export const LOGOUT = '/logout';
export const SIGNUP = '/signup';
